//
//
//
//
//
//

export default {
  name: 'MoreAD'
}



// WEBPACK FOOTER //
// ./src/components/MoreAD.vue